import { Button } from '@repo/ui/components/ui/button'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeftIcon, Compass, HomeIcon } from 'lucide-react'

export const Route = createFileRoute('/404')({
  component: NotFoundPage,
})

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen items-center justify-center px-4">
      <section className="mx-auto flex w-full max-w-3xl flex-col items-center gap-8 text-center">
        <div className="app-premium-panel relative w-full rounded-[6px] px-8 py-12 md:px-12">
          <div className="app-ambient-spot -left-10 -top-12 h-28 w-28 bg-primary/30" />
          <div className="app-ambient-spot -right-8 top-2 h-24 w-24 bg-accent/35" />
          <div className="relative">
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
              Navigation miss
            </p>
            <h1 className="mt-2 text-7xl font-bold tracking-tight text-foreground/90 md:text-8xl">
              404
            </h1>
            <p className="mx-auto mt-4 max-w-lg text-base text-muted-foreground md:text-lg">
              This route doesn&apos;t exist in your current workspace. Return to Home or backtrack
              to your last valid page.
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-center gap-3 sm:flex-row">
          <Button asChild variant="default" size="lg">
            <Link to="/">
              <HomeIcon className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
          <Button type="button" variant="outline" size="lg" onClick={() => window.history.back()}>
            <ArrowLeftIcon className="mr-2 h-4 w-4" />
            Go back
          </Button>
          <Button asChild variant="ghost" size="lg">
            <Link to="/notifications">
              <Compass className="mr-2 h-4 w-4" />
              Open signal inbox
            </Link>
          </Button>
        </div>
      </section>
    </main>
  )
}
